<template>
    <b-overlay :show="fuelsLoading" opacity="0.2" rounded="sm">
        <div class="row">
            <div class="col-12">
                <label class="form-label">Çalışma Şekli</label>
                <select class="form-control" v-model="value.PriceType" :disabled="routes.UncalculatedRoutes.length > 0">
                    <option v-for="tp in priceTypes" :key="tp.text" :value="tp.value">{{tp.text}}</option>
                </select>
                <span v-if="routes.UncalculatedRoutes.length > 0" class="badge badge-danger mt-25">{{routes.UncalculatedRoutes.length}} adet rota eklenmiştir. Çalışma şeklini değiştirmek için rota eklenmemiş olmalıdır.</span>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-6 mb-1">
                <label class="form-label">Firma</label>
                <v-validator :errors="errors" parameter="Firm" :watch="value.Firm">
                    <v-select-list v-model="value.Firm" :options="firms" label="Name" v-on:input="getLocations" v-on:search="searchFirms" placeholder="Firma" :loading="firmsLoading" img="Logo"></v-select-list>
                </v-validator>
            </div>
            <div class="col-md-6 mb-1">
                <label class="form-label">Firma Lokasyonu</label>
                <v-validator :errors="errors" parameter="FirmLocation" :watch="value.FirmLocation">
                    <v-select-list v-model="value.FirmLocation" :options="locations" label="LocationName" placeholder="Firma Lokasyonu" :disabled="value.Firm == null"></v-select-list>
                </v-validator>
            </div>
            <div class="col-md-6">
                <label class="form-label">Yakıt Firması İli</label>
                <v-validator :errors="errors" parameter="FuelProvince" :watch="value.Province">
                    <v-select-list v-model="value.Province" :options="provinces" label="Name" v-on:input="getDistricts" placeholder="Yakıt Firması İli"></v-select-list>
                </v-validator>
            </div>
            <div class="col-md-6">
                <label class="form-label">Yakıt Firması İlçesi</label>
                <v-validator :errors="errors" parameter="FuelDistrict" :watch="value.District">
                    <v-select-list :disabled="!value.Province" v-model="value.District" :options="districts" v-on:input="getCalculatedFuels" label="Name" placeholder="Yakıt Firması İlçesi"></v-select-list>
                </v-validator>
            </div>
            <div v-if="c_calculatedFuels.length" class="col-md-12 mt-1">
                <div class="row">
                    <template v-for="(cf,index) in c_calculatedFuels">
                        <div :key="index" class="mb-1 mb-md-0" :class="'col-md-'+(12/c_calculatedFuels.length)">
                            <v-validator :errors="errors" parameter="Fuel" :watch="value.Fuel">
                                <div class="validator-wrapper">
                                    <table class="table table-bordered mb-0">
                                        <tr class="fuel-brand" :class="cf.BrandCode" :key="'fb'+index">
                                            <td>
                                                <img height="75" :src="cf.Img">
                                            </td>
                                        </tr>
                                        <tr v-for="(price,p_index) in cf.FuelPrices" :key="'cf'+p_index+index">
                                            <td>
                                                <b-form-radio class="mt-25" :id="price.Id" v-model="value.Fuel" :value="price.FuelGroupPriceId" >
                                                    <b>{{price.FuelPriceType}}</b> | {{price.Price}}
                                                </b-form-radio>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </v-validator>
                        </div>
                    </template>
                </div>
            </div>
            <div v-if="!c_calculatedFuels.length && this.value.District && !fuelsLoading" class="col-md-12 mt-1">
                <div class="alert alert-dark">
                    <div class="alert-body">
                        Seçilen şehir ve ilçe için yakıt fiyat bilgisi bulunmamaktadır.
                    </div>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BSpinner,BFormRadio,BOverlay } from 'bootstrap-vue'
import FirmOperationsApi from '@/api/firm-operations'
import SystemDataApi from '@/api/system-data'
import FuelOperationsApi from '@/api/fuel-operations'
import randomatic from 'randomatic'

export default {
    components:{
        BSpinner,
        BFormRadio,
        BOverlay,
    },
    props:{
        value:Object,
        errors:Object,
        routes:Object
    },
    data(){
        return{
            firms:[],
            firmsLoading:false,
            fuelsLoading:false,
            provinces:[],
            districts:[],
            locations:[],
            calculatedFuels:[],
            priceTypes:[
                {text:'TL/TON',value:0},
                {text:'TL/KM',value:1},
                {text:'ROTA',value:2},
            ]
        }
    },
    mounted(){
        this.getProvinces()
    },
    watch:{
        "value.Province"(newValue,oldValue){
            if(newValue != oldValue){
                this.value.District = null
                this.value.Fuel = null
                this.calculatedFuels = []
            }
        },
        "value.Firm"(newValue,oldValue){
            if(newValue != oldValue){
                this.value.FirmLocation = null
            }
        }
    },
    methods:{
        searchFirms(search){
            if(search){
                this.firmsLoading = true
                FirmOperationsApi.List(search)
                .then(res=>{
                    this.firms = res.data.Data
                    this.firmsLoading = false
                }).catch(err=>{ this.firmsLoading = false })
            }
        },
        getProvinces(){
            //only turkey
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241').then(response=>{
                this.provinces = response.data.Data
            })
        },
        getLocations(){
            if(this.value.Firm?.Id){
                FirmOperationsApi.Location.List(this.value.Firm?.Id).then(res=>{
                    this.locations = res.data.Data
                })
            }
        },
        getDistricts(){
            if(this.value.Province?.Id){
                SystemDataApi.District(this.value.Province.Id)
                .then(res=>{
                    this.districts = res.data.Data
                })
            }
        },
        getCalculatedFuels(){
            if(this.value.Province?.Id && this.value.District?.Id){
                this.fuelsLoading = true
                FuelOperationsApi.ByLocation(this.value.Province.Id,this.value.District.Id).then(res=>{
                    this.calculatedFuels = res.data.Data
                    this.fuelsLoading = false
                }).catch(err=>{
                    this.fuelsLoading = false
                })
            }
        }
    },
    computed:{
        c_calculatedFuels(){
            return this.calculatedFuels.map(cf=>{
                cf.Img = require('@/assets/images/petrol-brand/'+ cf.BrandCode +'.svg')
                cf.FuelPrices = cf.FuelPrices.map(fp=>{
                    fp.Id = randomatic('A0',10)
                    return fp
                })
                return cf
            })  
        },
    }
}
</script>

<style>
    .fuel-brand.PO,
    .fuel-brand.PO:hover{
        border-color: rgb(235, 25, 35);
        background-color: rgb(235, 25, 35,0.2);
    }

    .fuel-brand.OPET,
    .fuel-brand.OPET:hover{
        border-color: rgb(0, 124, 195);
        background-color: rgba(0, 124, 195,0.2);
    }

    .fuel-brand.BP,
    .fuel-brand.BP:hover{
        border-color: rgb(51, 164, 87);
        background-color: rgba(51, 164, 87,0.2);
    }
    
    .fuel-brand.TOTAL,
    .fuel-brand.TOTAL:hover{
        border-color: rgb(228, 3, 46);
        background-color: rgba(228, 3, 46,0.2);
    }

    .fuel-brand img{
        height: 20px;
        width: auto;
    }
</style>